/** ₹ in lakh with one decimal, as the X4 mockup: ₹10.6 L, ₹20 L. */
export function formatLakh(amount: number): string {
  const lakh = Math.round((Number(amount) / 100000) * 10) / 10;
  return `₹${Number.isInteger(lakh) ? lakh.toFixed(0) : lakh.toFixed(1)} L`;
}
